import { DoCloudGameStopHS, DWCloudGameShouldFeedBack } from 'src/commons/store/CloudGameStore'
import { AppStore, GameLibraryStore } from 'src/pc/store/AppStore'
import { stringify } from 'querystring'
import { getPhpToken } from 'src/pc/utils/auth'
import { getUserInfo } from 'src/pc/store/UserStore'
import { generatorUUID } from 'src/pc/store/cloudGame/utils'
import { CLOUD_GAME_EXIT_TYPE, CLOUD_GAME_PROGRESS_STATUS } from 'src/pc/store/cloudGame/cloudGameHelper'
import clientPostMessage, { FrameOrigins } from 'src/pc/store/cloudGame/clientPostMessage'
import CloudGameClientStore from 'src/pc/store/cloudGame/cloudGameClientStore'
import SocketStore from 'src/pc/store/cloudGame/socket'
let timer: number | null = null
// 游戏运行心跳
export const gameIsRunningCheck = (gameCloudOrderNo: string, option?: { clearOnly: boolean }) => {
  timer && clearInterval(timer)
  timer = null
  if (!option?.clearOnly) {
    timer = window.setInterval(() => {
      SocketStore.send({
        packetNo: generatorUUID().replace(/-/g, 'x'),
        messageGroup: 'GAME_CLOUD',
        systemId: '99box',
        messageCode: 'cloud_game_running',
        data: { gameCloudOrderNo },
      })
    }, 1000 * 55)
  }
}

const useCloudGameStart = () => {
  /**
   * 启动云游戏
   * @param gameCloudOrderNo 云游戏启动单号
   * @param url 云游戏窗口url
   */
  const runCloudGame = async (gameCloudOrderNo: string, url: string) => {
    /** 清除之前的上号timeout计时器 */
    clearTimeOutCheck()
    console.debug(
      '云游戏启动进度-开始启动(参数拼接完成转为挂盘中状态)',
      CLOUD_GAME_PROGRESS_STATUS.GAME_INSTALLING,
      new Date().toLocaleString(),
    )
    SocketStore.send({
      packetNo: generatorUUID().replace(/-/g, 'x'),
      messageGroup: 'GAME_CLOUD',
      systemId: '99box',
      messageCode: 'cloud_game_version',
      data: { gameCloudOrderNo, supportDelayArchival: true, details: null },
    })
    CloudGameStartProgress.setStep(CLOUD_GAME_PROGRESS_STATUS.GAME_INSTALLING)
    CloudGameClientStore.cloudGameIframe.iframeSrc = url
    CloudGameClientStore.gameCloudNo = gameCloudOrderNo
    /** 启动超时的定时器 */
    checkCloudTimer = window.setTimeout(() => {
      stopCloudGame({
        needRequest: true,
        reason: CLOUD_GAME_EXIT_TYPE.CLIENT_START_TIME_OUT.reason,
        needArchive: false,
      })
      CloudGameClientStore.cloudGameStartCrash = CLOUD_GAME_EXIT_TYPE.CLIENT_START_TIME_OUT
      checkCloudTimer = null
    }, 60 * 1000 * 5)
  }

  const startCloudGame = async ({
    gameCloudOrderNo,
    gameJson,
    cloudArchive,
    isHang,
  }: {
    gameCloudOrderNo: string
    startGameNo?: string
    gameId?: number
    gameJson: string
    queue?: boolean
    cloudArchive?: TFinalArchive
    isHang: boolean
  }) => {
    const Authorization = getPhpToken()
    if (!Authorization) {
      return
    }
    CloudGameStartProgress.reset()
    CloudGameClientStore.cloudPageStatus = false
    console.debug(`当前游戏启动 ${!isHang ? '不' : ''} 需要挂盘`)
    console.debug(
      '云游戏启动进度-开始启动(拼接启动参数)',
      CLOUD_GAME_PROGRESS_STATUS.LOCK_DEVICE,
      new Date().toLocaleString(),
    )
    CloudGameStartProgress.setStep(CLOUD_GAME_PROGRESS_STATUS.LOCK_DEVICE)
    const json = gameJson ? JSON.parse(gameJson) : {}
    const userId = localStorage.getItem('user_id') || ''
    if (cloudArchive) {
      json.cloudArchiveOrder = cloudArchive.orderNo
      json.cloudOssPath = cloudArchive.key.split('#')[0]
    }
    json.disableWs = true
    json.prod_type = 'box'
    json.userId = userId
    json.parent = encodeURIComponent(window.origin)
    json.isHang = +isHang
    json.linkUid = CloudGameClientStore.linkUid
    /** 缓存appId, 邀请玩家时需要使用 */
    if (json.appId) {
      localStorage.setItem('t_cloud_sdk_app_id', json.appId)
    }
    try {
      const userInfo = await getUserInfo(Authorization)
      if (userInfo.hasInvitationRight) {
        json.userType = 'host'
      }
      const url = `${FrameOrigins[process.env.BUILD_TYPE]}?Authorization=${Authorization}&${stringify(json)}`
      await runCloudGame(gameCloudOrderNo, url)
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * 云游戏停止 通知客户端和服务端 并修改前端状态
   * @param needRequest 是否需要通知服务端停止计费
   */
  const stopCloudGame = async ({
    needRequest = true,
    reason = '',
    needArchive = true,
    needFeedBack,
  }: {
    needRequest: boolean
    reason: string
    needArchive?: boolean
    needFeedBack?: boolean
  }) => {
    if (!['starting', 'running'].includes(GameLibraryStore.gameRunStatus)) {
      return
    }
    CloudGameStartProgress.reset()
    const GameCloudNo = CloudGameClientStore.gameCloudNo
    const supportArchive = GameLibraryStore.currentTheRunningGameInfo?.isSupportArchive === 1
    const shouldWaitArchive =
      GameCloudNo && GameLibraryStore.gameRunStatus === 'running' && needArchive && supportArchive
    if (!shouldWaitArchive) {
      CloudGameClientStore.gameCloudNo = ''
    }
    gameIsRunningCheck('', { clearOnly: true })
    clearTimeOutCheck()
    if (needRequest && GameCloudNo) {
      console.log('调用停止计费接口')
      DoCloudGameStopHS.Execute({ gameCloudOrderNo: GameCloudNo, reason })
    }
    if (needFeedBack) {
      DWCloudGameShouldFeedBack.Execute().then(should => {
        if (!should) {
          return
        }
        if (shouldWaitArchive) {
          setTimeout(() => {
            AppStore.cloudGameFeedBackVisible = true
          }, 2000)
        } else {
          AppStore.cloudGameFeedBackVisible = true
        }
      })
    }
    if (shouldWaitArchive) {
      console.log('需要等待存档上传, 隐藏云游戏窗口')
      CloudGameClientStore.cloudPageStatus = false
    } else {
      console.log('不需要等待存档上传, 关闭云游戏窗口')
      CloudGameClientStore.cloudGameIframe.iframeSrc = 'about:blank'
    }
    if (GameCloudNo) {
      GameLibraryStore.gameRunStatus = 'waitClose'
      /** 等待存档保存 */
      shouldWaitArchive && (await awaitSoure.finish(30000, false))
      shouldWaitArchive && console.log('存档等待结束, 关闭云游戏窗口')
      shouldWaitArchive && window.FuluApp?.JSNotifyCppFunc('close_cloud_game')
      /** 等待云游戏设备释放 */
      /**
       * 2022/6/29
       * 这里之前的作用是 申请云机器 是用的用户token申请的， 同一个用户 假如在上一个机器还没有释放完毕的时候 就又申请云机器 可能导致会分配到上一个还没有完全释放的机器
       * 这里因为后端已经把申请设备的token改为上号单号了。 所以上一个机器释放不释放已经无所谓了， 所以直接移除等待代码
       *  */
      // await awaitSoure.finish(15000, true)
    }
    GameLibraryStore.gameRunStatus = 'stop'
  }

  return {
    startCloudGame,
    stopCloudGame,
  }
}

export default useCloudGameStart

/** 等待云存档保存弹窗通知 */
export const awaitSoure: { done: Function | null; finish: (timeout?: number, onlyTimeout?: boolean) => Promise<any> } =
  {
    done: null,
    finish(timeout = 30000, onlyTimeout = false) {
      const start = Date.now()
      const promises = [
        new Promise(resolve => {
          setTimeout(resolve, timeout)
        }),
      ]
      if (!onlyTimeout) {
        promises.unshift(
          new Promise(resolve => {
            this.done = (v: unknown) => {
              resolve(v)
              this.done = null
            }
          }),
        )
      }
      return Promise.race(promises).then(v => {
        console.log('finished', Date.now() - start)
        return v
      })
    },
  }

interface ProgressOption {
  interval?: number
  onchange: (step: number) => void
}

const loop = () => {}

export class CLOUD_GAME_PROGRESS {
  state: 'on' | 'off' | 'done' = 'off'
  timer: number | null = null
  interval: number = 1000
  targetStep: number = 0
  step: number = 0
  onchange: (step: number) => void = loop
  constructor({ interval = 1000, onchange = loop }: ProgressOption) {
    this.interval = interval
    this.onchange = onchange
  }
  setStep(n: number) {
    if (this.state === 'done') {
      return
    }
    if (n > this.targetStep) {
      this.targetStep = n
      if (this.state === 'off') {
        this.updateProgress()
      }
    }
  }
  updateProgress() {
    this.state = 'on'
    if (this.step >= this.targetStep) {
      this.state = 'off'
      return
    }
    this.timer = window.setTimeout(() => {
      this.step++
      this.onchange(this.step)
      this.updateProgress()
    }, this.interval)
  }
  finish() {
    this.state = 'done'
  }
  reset() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.step = 0
    this.targetStep = 0
    this.onchange(this.step)
  }
}

export const CloudGameStartProgress = new CLOUD_GAME_PROGRESS({
  onchange(step) {
    CloudGameClientStore.cloudGameStartProcess = step
    clientPostMessage.post({
      code: 'start-progress',
      process: {
        step,
        stepText: CLOUD_GAME_PROGRESS_TEXT[step],
      },
    })
  },
})

export enum CLOUD_GAME_PROGRESS_TEXT {
  '链接云服务器中' = 1,
  '云端游戏安装中' = 2,
  '链接云电脑服务' = 3,
  '启动游戏客户端' = 4,
  '启动成功' = 5,
}

let checkCloudTimer: number | null = null

export const clearTimeOutCheck = () => {
  if (checkCloudTimer) {
    window.clearTimeout(checkCloudTimer)
    checkCloudTimer = null
  }
}
